import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PROPERTY_TYPE = {
  APARTMENT: 'apartment',
  HOUSE: 'house',
} as const;

export const PROPERTY_TYPE_NAME = 'property_type';

interface Props {
  name?: string;
}

export const RadioGroupPropertyType: FC<Props> = ({
  name = PROPERTY_TYPE_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Typ nieruchomości')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${PROPERTY_TYPE.APARTMENT}`}
                value={PROPERTY_TYPE.APARTMENT}
                label={i18n.t('Mieszkanie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${PROPERTY_TYPE.HOUSE}`}
                value={PROPERTY_TYPE.HOUSE}
                label={i18n.t('Dom (na działce)')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
